// make sure each enum value is proprtional to ServiceSelectedFilterResource properties.
export enum ServiceFilterType {
  BpsValue = 'bpsValue',
  Years = 'years',
  Makes = 'makes',
  Models = 'models',
  IsTrimConfirmationRequired = 'isTrimConfirmationRequired',
  Trims = 'trims',
  SalesPersons = 'salesPersons',
  ServiceAdvisors = 'serviceAdvisors',
  ROStatuses = 'roStatuses',
  DealTypes = 'dealTypes',
  DateRange = 'dateRange',
  InteractionStatuses = 'interactionStatuses',
  EmailStatus = 'emailValidationStatus',
  OptOutPreference = 'optOutPreference',
}
